/**
 * Utility functions for handling remedy IDs and UUIDs
 */

/**
 * Get the remedy identifier to use in API calls
 * Prefers UUID if available, falls back to numeric ID
 */
export function getRecipeIdentifier(recipe: {
  uuid?: string;
  id?: string | number;
}): string {
  // Prefer UUID if available
  if (recipe.uuid) {
    return recipe.uuid;
  }
  // Fallback to numeric ID (convert to string)
  if (recipe.id !== undefined && recipe.id !== null) {
    return String(recipe.id);
  }
  throw new Error('Remedy must have either uuid or id');
}

/**
 * Get recipe identifier from a string/number (could be UUID or numeric ID)
 * This is used when we only have the identifier, not the full recipe object
 */
export function normalizeRecipeId(
  id: string | number | undefined | null,
): string {
  if (!id) {
    throw new Error('Remedy ID is required');
  }
  return String(id);
}
